import React from 'react';
import { TranslationKeys } from '../../../core/constants/translationKeys';

export function Reconnect({ t }) {
  return (
    <div className='no-connection-bl'>
      <i className='icon-connection' />
      <p>{t(TranslationKeys.Reconnect)}</p>
    </div>
  );
}
